import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { pluralize } from "shared/Pluralize";

import { FlowsProjectRow } from "../types";

const FlowsProjectsListAssignedRolesCell = ({
  item: project,
  ...cellProps
}: TableSimpleCellProps<FlowsProjectRow>) => (
  <TableSimpleCell {...cellProps}>
    <TableCellText>
      {project.assignedRoles} {pluralize("role", project.assignedRoles)}
    </TableCellText>
  </TableSimpleCell>
);

export default FlowsProjectsListAssignedRolesCell;
